import { Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { CandidateHomeNavigationService } from '@candidate/app/services/candidate-home-navigation.service'
import { CommunitiesMainPage, CommunityNavigationService } from '@engineering11/community-web'
import { ConversationStore } from '@engineering11/messaging-web'
import { UiScrollLockingService, ViewportService } from '@engineering11/web-utilities'
import { Observable, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { CnectFeatures, ConfigStore, ConversationTypes } from 'shared-lib'

type DropdownMenu = 'community' | 'network'

type Tabs = 'home' | 'messages'

@Component({
  selector: 'app-mobile-side-drawer-menu',
  templateUrl: './mobile-side-drawer-menu.component.html',
  styleUrls: ['./mobile-side-drawer-menu.component.scss'],
})
export class MobileSideDrawerMenuComponent implements OnInit, OnDestroy {
  features$: Observable<CnectFeatures | undefined> = this.configStore.features$
  ConversationTypes = ConversationTypes
  mobileSideDrawerToggledState$ = this.candidateNavigationService.mobileSideDrawerToggledState$
  communitiesPageEnum = CommunitiesMainPage
  unreadConversationCount$ = this.conversationStore.getUnreadConversationCount
  UNREAD_LIMIT = 9
  isMobile$ = this.viewportService.belowBreakpoint('lg')

  selectedDropdownMenu: DropdownMenu | null = null
  selectedTab: Tabs = 'home'
  navigationItems = this.candidateNavigationService.navigationItems
  isOpen = false
  destroy$: Subject<boolean> = new Subject<boolean>()

  constructor(
    private scrollLockService: UiScrollLockingService,
    private candidateNavigationService: CandidateHomeNavigationService,
    private communityNavigationService: CommunityNavigationService,
    private router: Router,
    private conversationStore: ConversationStore,
    private configStore: ConfigStore,
    private viewportService: ViewportService
  ) {}

  ngOnInit(): void {
    this.mobileSideDrawerToggledState$.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (value) {
        return this.open()
      }

      this.close()
    })

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event instanceof NavigationEnd && this.isOpen) {
        this.close(true)
      }
    })
    this.isMobile$.pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      if (!isMobile && this.isOpen) {
        this.close(true)
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  open() {
    this.isOpen = true
    this.scrollLockService.scrollLock(true)
  }

  close(shouldEmit = false) {
    this.scrollLockService.scrollLock(false)
    this.isOpen = false

    if (shouldEmit) {
      this.candidateNavigationService.mobileSideDrawerToggle$.next(false)
      this.scrollLockService.scrollLock(false)
    }
  }

  toggleDropdownMenu(menu: DropdownMenu) {
    if (this.selectedDropdownMenu === menu) {
      this.selectedDropdownMenu = null
      return
    }

    this.selectedDropdownMenu = menu
  }

  // @Todo: Refactor this.scrollLockService.scrollLock(false)
  routeToPath(path: string | any) {
    this.scrollLockService.scrollLock(false)
    this.router.navigate([path])
  }

  communitiesPage(page: CommunitiesMainPage) {
    this.scrollLockService.scrollLock(false)
    this.communityNavigationService.communities({ page })
  }

  networkConnections() {
    this.scrollLockService.scrollLock(false)
    this.candidateNavigationService.networkConnections()
  }

  networkInvitations() {
    this.scrollLockService.scrollLock(false)
    this.candidateNavigationService.networkInvitations()
  }
}
